import { InputText } from 'primereact/inputtext';
import { useState } from "react";

function Home() {
    const [question, setQuestion] = useState('');

    const chatScenarios = [
        { id: 0, name: 'Bagaimana Cara Mengajukan Pinjaman?', profession: 'mathematician', },
        { id: 1, name: 'Berapa Jumlah Minimum dan Maksimum Pengajuan Pinjaman?', profession: 'chemist', },
        { id: 2, name: 'Status pengajuan pinjaman saya bagaimana ?', profession: 'physicist', },
        { id: 3, name: 'Berapa nominal kalau mau mendanai', profession: 'chemist', },
        { id: 4, name: 'Apakah ada biaya untuk menjadi Pemberi Pinjaman', profession: 'astrophysicist', }];

    const chemists = chatScenarios.filter(chatScenario =>
        chatScenario.profession === 'chemist'
    );

    const listItems = chemists.map(person =>
        <button className='accordion-faq'>{person.name}</button>
    );

    return (
        <>
            <div className="hero-backgrounds">
                <div className="hero-background-faq-detail">
                    <div className="hero-background-title-blue"></div>
                </div>
            </div>

            <article className="hero-new">
                <div className="hero-message-wrapper faq" style={{ top: '35%' }}>
                    <div className="hero-logo">
                        <h1>
                            FAQ
                        </h1>
                        <p>
                            Daftar pertanyaan yang sering ditanyakan
                        </p>
                        <br />
                        <InputText id='question' className='input-search' value={question} onChange={(q) => setQuestion(q.target.value)} />
                    </div>
                </div>
                <div className="card-faq" style={{ display: 'block' }} id="divQuestion">
                    <div id="cardQuestion" >
                        {listItems}
                        <a href="#lihatSemua">
                            <button id="btn-hide" className="accordion-lihat-semua"
                                style={{ display: 'block', fontSize: '15px', fontFamily: 'Lato-Regular' }}>
                                Lihat Semua
                            </button>
                        </a>
                        <button id="btn-noResult" className="accordion-lihat-semua"
                            style={{ display: 'block', fontSize: '15px', fontFamily: 'Lato-Regular' }}>Maaf, saya tidak dapat memahami maksud Anda.</button>
                    </div>

                </div>
            </article>

        </>
    );
}

export default Home;
